import React from "react";
import styled from "styled-components/macro";
import { Checkbox } from "@mui/material";
import { Trans } from "react-i18next";

const CheckLabel = styled.label<{ checked: boolean }>`
  position: absolute;
  display: flex;
  align-items: center;
  margin-top: -45px;
  margin-left: 5px;
  font-size: 12px;
  line-height: 1.4em;
  cursor: pointer;
  opacity: ${({ checked }) => (checked ? 0.9 : 0.8)};
  color: ${({ theme, checked }) => (checked ? theme.duo.color.text : theme.duo.color.textGrey)};
  .MuiCheckbox-root {
    padding: 3px;
  }
`;

type Props = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  sourceName?: string;
};

const SynchronizeCheckbox: React.FC<Props> = ({ checked, onChange, sourceName }) => {
  return (
    <CheckLabel checked={checked}>
      <Checkbox size="small" checked={checked} onChange={() => onChange(!checked)} />
      {sourceName ? (
        <>
          <Trans parent="div">Synchronize to:</Trans>
          <strong>{sourceName}</strong>
        </>
      ) : (
        <Trans parent="div">Synchronize in your deck</Trans>
      )}
    </CheckLabel>
  );
};

export default SynchronizeCheckbox;
